import React from 'react'
import $ from 'jquery';
import { useTranslation } from 'react-i18next';
const Terms = () => {
  const {t} = useTranslation()
  $(function () {
    $('.terms-tabs .tab').on('click', function () {
      $('.tab').removeClass('active');
      $(this).addClass('active')
      var scrollTo = $(this).attr('href');
      $('html , body').animate({

        scrollTop: $(scrollTo).offset().top - 100
      }, 200);
    });

  })
  return (
    <div className='terms'>
      <div className='terms-header'>
        <h1>{t('terms:headTitle')}</h1>
        <p>{t('terms:headInfo')}</p>
      </div>
      <div className='row'>
        <div className='col-md-2'>
          <div className='terms-tabs'>
            <a href='#obligations' className='tab active'>{t('terms:rightOfDexef.maintitle')}</a>
            <a href='#RightsOfCustomer' className='tab'>{t('terms:rightOfCustomer.maintitle')}</a>
            <a href='#SHAREDOBLIGATIONS' className='tab '>{t('terms:rightBetween.maintitle')}</a>
            <a href='#TermsAndConditions' className='tab '>{t('terms:termsAndConditions.maintitle')}</a>
            <a href='#PrivacyPolicy' className='tab'>{t('terms:privacyPolicy.maintitle')}</a>
            <a href='#RefundPolicy' className='tab'>{t('terms:RefundPolicy.maintitle')}</a>
          </div>
        </div>
        <div className='col-md-10'>
          <div className='terms-content'>

            <h1 id='obligations'>{t('terms:rightOfDexef.maintitle')}</h1>
            <ul>
              <li>{t('terms:rightOfDexef.stepOne')}</li>
              <li>{t('terms:rightOfDexef.setpTwo')}</li>
              <li>{t('terms:rightOfDexef.setpThree')}</li>
              <li>{t('terms:rightOfDexef.setpFour')}</li>
              <li>{t('terms:rightOfDexef.setpFive')}</li>
              <li>{t('terms:rightOfDexef.setpSix')}</li>
              <li>{t('terms:rightOfDexef.setpSeveen')}</li>
              <li>{t('terms:rightOfDexef.setpEight')}</li>
            </ul>


            <h1 id='RightsOfCustomer'>{t('terms:rightOfCustomer.maintitle')}</h1>
            <ul>
              <li>{t('terms:rightOfCustomer.stepOne')}</li>
              <li>{t('terms:rightOfCustomer.setpTwo')}</li>
              <li>{t('terms:rightOfCustomer.setpThree')}</li>
              <li>{t('terms:rightOfCustomer.setpFour')}</li>
              <li>{t('terms:rightOfCustomer.setpFive')}</li>
              <li>{t('terms:rightOfCustomer.setpSix')}</li>
              <li>{t('terms:rightOfCustomer.setpSeveen')}</li>
              <li>{t('terms:rightOfCustomer.setpEight')}</li>
            </ul>


            <h1 id='SHAREDOBLIGATIONS'>{t('terms:rightBetween.maintitle')}</h1>
            <ul>
              <li>{t('terms:rightBetween.stepOne')}</li>
              <li>{t('terms:rightBetween.setpTwo')}</li>
              <li>{t('terms:rightBetween.setpThree')}</li>
            </ul>

            <h1 id='TermsAndConditions'>{t('terms:termsAndConditions.maintitle')}</h1>
            <ul>
              <li>{t('terms:termsAndConditions.stepOne')}</li>
              <li>{t('terms:termsAndConditions.setpTwo')}</li>
              <li>{t('terms:termsAndConditions.setpThree')}</li>
              <li>{t('terms:termsAndConditions.setpFour')}</li>
              <li>{t('terms:termsAndConditions.setpFive')}</li>
              <li>{t('terms:termsAndConditions.setpSix')}</li>
            </ul>

            <h1 id='PrivacyPolicy'>{t('terms:privacyPolicy.maintitle')}</h1>
            <ul>
              <li>{t('terms:privacyPolicy.stepOne')}</li>
              <li>{t('terms:privacyPolicy.setpTwo')}</li>
              <li>{t('terms:privacyPolicy.setpThree')}</li>
              <li>{t('terms:privacyPolicy.setpFour')}</li>
              <li>{t('terms:privacyPolicy.setpFive')}</li>
              <li>{t('terms:privacyPolicy.setpSix')} </li>
              <li>{t('terms:privacyPolicy.setpSeveen')}</li>
            </ul>

            <h1 id='RefundPolicy'>{t('terms:RefundPolicy.maintitle')}</h1>
            <ul>
            <li>{t('terms:RefundPolicy.stepOne')}</li>
              <li>{t('terms:RefundPolicy.setpTwo')}</li>
              <li>{t('terms:RefundPolicy.setpThree')}</li>
              <li>{t('terms:RefundPolicy.setpFour')}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Terms